import { ModuleFields } from "~/Utils/drilldownData";

export const announcementDrilldownData: ModuleFields[] = [
  {
    fieldName: "Tender Heading (EN)",
    fieldValue: "field_tender_pre_heading_en",
    className: "col-span-6",
    type: "text",
    name: "field_tender_pre_heading_en",
    formType: "input",
    label: "Tender Heading (EN)",
    placeholder: "Enter Tender Heading (EN)",
    validation: { required: "Tender Heading (EN) is required" },
  },
  {
    fieldName: "Tender Heading (MS)",
    fieldValue: "field_tender_pre_heading_ms",
    className: "col-span-6",
    type: "text",
    name: "field_tender_pre_heading_ms",
    formType: "input",
    label: "Tender Heading (MS)",
    placeholder: "Enter Tender Heading (MS)",
  },
  {
    fieldName: "Tender Heading (ZH)",
    fieldValue: "field_tender_pre_heading_zh",
    className: "col-span-6",
    type: "text",
    name: "field_tender_pre_heading_zh",
    formType: "input",
    label: "Tender Heading (ZH)",
    placeholder: "Enter Tender Heading (ZH)",
  },
  {
    fieldName: "Tender Calling Date",
    fieldValue: "field_tender_calling_date",
    className: "col-span-6",
    type: "date",
    name: "field_tender_calling_date",
    formType: "date",
    label: "Tender Calling Date",
    placeholder: "Select Tender Calling Date",
    validation: { required: "Tender Calling Date is required" },
  },
  {
    fieldName: "Tender Closing Date",
    fieldValue: "field_tender_closing_date",
    className: "col-span-6",
    type: "date",
    name: "field_tender_closing_date",
    formType: "date",
    label: "Tender Closing Date",
    placeholder: "Select Tender Closing Date",
    validation: { required: "Tender Closing Date is required" },
  },
  // {
  //   fieldName: "Tender Main Heading (EN)",
  //   fieldValue: "field_tender_main_heading",
  //   className: "col-span-6",
  //   type: "text",
  //   name: "field_tender_main_heading",
  //   formType: "input",
  //   label: "Tender Main Heading (EN)",
  //   placeholder: "Enter Tender Main Heading (EN)",
  //   validation: { required: "Tender Main Heading (EN) is required" },
  // },
  // {
  //   fieldName: "Tender Main Heading (MS)",
  //   fieldValue: "field_tender_main_heading_ms",
  //   className: "col-span-6",
  //   type: "text",
  //   name: "field_tender_main_heading_ms",
  //   formType: "input",
  //   label: "Tender Main Heading (MS)",
  //   placeholder: "Enter Tender Main Heading (MS)",
  // },
  // {
  //   fieldName: "Tender Main Heading (ZH)",
  //   fieldValue: "field_tender_main_heading_zh",
  //   className: "col-span-6",
  //   type: "text",
  //   name: "field_tender_main_heading_zh",
  //   formType: "input",
  //   label: "Tender Main Heading (ZH)",
  //   placeholder: "Enter Tender Main Heading (ZH)",
  // },

  {
    fieldName: "Tender Remark (EN)",
    fieldValue: "field_tender_remark",
    className: "col-span-6",
    type: "textarea",
    name: "field_tender_remark",
    formType: "textarea",
    label: "Tender Remark (EN)",
    placeholder: "Enter Tender Remark (EN)",
    // validation: { required: "Tender Remark (EN) is required" },
  },
  {
    fieldName: "Tender Remark (MS)",
    fieldValue: "field_tender_remark_ms",
    className: "col-span-6",
    type: "textarea",
    name: "field_tender_remark_ms",
    formType: "textarea",
    label: "Tender Remark (MS)",
    placeholder: "Enter Tender Remark (MS)",
  },
  {
    fieldName: "Tender Remark (ZH)",
    fieldValue: "field_tender_remark_zh",
    className: "col-span-6",
    type: "textarea",
    name: "field_tender_remark_zh",
    formType: "textarea",
    label: "Tender Remark (ZH)",
    placeholder: "Enter Tender Remark (ZH)",
  },
  {
    fieldName: "Project Location (EN)",
    fieldValue: "field_tender_venue",
    className: "col-span-6",
    type: "text",
    name: "field_tender_venue",
    formType: "input",
    label: "Project Location (EN)",
    placeholder: "Enter Project Location (EN)",
    validation: { required: "Project Location (EN) is required" },
  },
  {
    fieldName: "Project Location (MS)",
    fieldValue: "field_tender_venue_ms",
    className: "col-span-6",
    type: "text",
    name: "field_tender_venue_ms",
    formType: "input",
    label: "Project Location (MS)",
    placeholder: "Enter Project Location (MS)",
  },
  {
    fieldName: "Project Location (ZH)",
    fieldValue: "field_tender_venue_zn",
    className: "col-span-6",
    type: "text",
    name: "field_tender_venue_zn",
    formType: "input",
    label: "Project Location (ZH)",
    placeholder: "Enter Project Location (ZH)",
  },
  {
    fieldName: "Extended Tender Closing",
    fieldValue: "field_tender_time",
    className: "col-span-6",
    type: "dateTime",
    name: "field_tender_time",
    formType: "dateTime",
    label: "Extended Tender Closing",
    placeholder: "Enter Extended Tender Closing",
    // validation: { required: "Extended Tender Closing is required" },
  },
  {
    fieldName: "Tender Content (EN)",
    fieldValue: "field_tender_content",
    className: "col-span-6",
    type: "text",
    name: "field_tender_content",
    formType: "richText",
    label: "Tender Content (EN)",
    placeholder: "Enter Tender Content (EN)",
    validation: { required: "Tender Content (EN) is required" },
  },
  {
    fieldName: "Tender Content (MS)",
    fieldValue: "field_tender_content_ms",
    className: "col-span-6",
    type: "text",
    name: "field_tender_content_ms",
    formType: "richText",
    label: "Tender Content (MS)",
    placeholder: "Enter Tender Content (MS)",
  },
  {
    fieldName: "Tender Content (ZH)",
    fieldValue: "field_tender_content_zh",
    className: "col-span-6",
    type: "text",
    name: "field_tender_content_zh",
    formType: "richText",
    label: "Tender Content (ZH)",
    placeholder: "Enter Tender Content (ZH)",
  },
  {
    fieldName: "Published",
    fieldValue: "published",
    className: "col-span-12",
    type: "checkbox",
    name: "published",
    formType: "checkbox",
    label: "Published",
    placeholder: "Published",
  },
];
